import store from "../../redux/reducers";
import {
  setScreen,
  setConfiguration,
  setAllConsentSwitch,
  setAllObjectConsentSwitch,
} from "../../redux/actions";
import parseVendorConsent from "./parseVendorConsent";

const allPurposes = (tcData) => {
  if (!tcData.purposeConsent || typeof tcData.purposeConsent !== 'object') {
    return false;
  }
  return Object.values(tcData.purposeConsent).every(Boolean);
};

const allInterests = (tcData) => {
  if (!tcData.vendorList || !tcData.vendorList.purposes || !Array.isArray(tcData.vendorList.purposes)) {
    return false;
  }
  return tcData.vendorList.purposes
    .filter(
      (purpose) =>
        typeof tcData.static?.purposeLegitimateInterest?.[purpose.id] !==
        "boolean"
    )
    .every((purpose) => tcData.purposeLegitimateInterest[purpose.id]);
};

const switchScreenButton = async (configuration, screen = 2) => {
  const currentState = store.getState();

  if (!configuration.consentGiven) {
    let config = { ...configuration };
    config.defaultConsent = false;
    config.defaultObjectConsent = false;
    const consent = parseVendorConsent(config);
    config.vendorConsent = consent.vendorConsent;
    config.objectConsent = consent.objectConsent;
    config.purposeConsent = consent.purposeConsent;
    config.purposeLegitimateInterest = consent.purposeLegitimateInterest;
    config.specialFeatureOptins = consent.specialFeatureOptins;
    config.consentMode = consent.consentMode;
    config.consentSwitchValue = allPurposes(config);
    config.objectConsentSwitchValue = allInterests(config);

    store.dispatch(setConfiguration(config, currentState.currentLanguage.code));
    store.dispatch(setAllConsentSwitch(allPurposes(config)));
    store.dispatch(setAllObjectConsentSwitch(allInterests(config)));
  }

  store.dispatch(setScreen(screen));
};

const switchScreenButton2 = async (configuration, screen = 4) => {
  store.dispatch(setScreen(screen));
};

export { switchScreenButton, switchScreenButton2, allInterests, allPurposes };
